import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    noHeader: {
      '& .MuiToolbar-regular': {
        minHeight: '0 !important'
      },
      '@media (min-width: 600px)': {
        '& .MuiToolbar-regular': {
          minHeight: '0 !important'
        }
      },
      '@media (min-width: 0px) and (orientation: landscape)': {
        '& .MuiToolbar-regular': {
          minHeight: '0 !important'
        }
      }
    },
    form: {
      marginBottom: theme.spacing(2)
    },
    table: {
      marginBottom: theme.spacing(2)
    }
  })
